import request from '@/utils/request'
// 找货必看
export function getFindList (params) {
  return request({
    url: '/api/z/mchtShop/getGoodStuffList',
    method: 'post',
    params
  })
}
// 供应商搜索结果
export function getMchtSerchResult (params) {
  return request({
    url: 'api/z/getMchtSerchResult',
    method: 'post',
    params
  })
}
// 获取商家信息
export function getShopInfo (params) {
  return request({
    url: '/api/z/mchtShop/getMchtBaseInfo',
    method: 'post',
    params
  })
}
// 商家商品列表
export function getShopGoodsList (params) {
  return request({
    url: '/api/z/mchtShop/getMchtProductList',
    method: 'post',
    data: params
  })
}
// 获取店铺信息【关于店铺】
export function getShopAbout (params) {
  return request({
    url: '/api/z/mchtShop/getMchtShopInfo',
    method: 'post',
    params
  })
}
// 商家分类数据
export function getShopClassifyList (params) {
  return request({
    url: '/api/z/category/getMchtCategoryList',
    method: 'post',
    params
  })
}
// 修改店铺浏览数
export function visitShop (params) {
  return request({
    url: '/api/z/updateMchtVisit',
    method: 'post',
    params
  })
}
// 店铺商品下架公告
export function getNoticeInfo (params) {
  return request({
    url: '/api/z/info/notice',
    method: 'get',
    params
  })
}
// 根据域名获取店铺ID
export function getShopIdByDomain (params) {
  return request({
    url: '/api/z/mchtShop/getMchtIdByDomain',
    method: 'get',
    params
  })
}